

<template>
  <div>
   
    <main class="main product-details-main">
      <PagesPath class="py-4" path-title1="  لیست محصولات ارسال رایگان" :pathTo1="$route.path" />
      <!-- <HomeCategoreis/> -->
      <div class="baner_flash container">
        <router-link
          :to="'/FreeShipping'"
          class="products__slider__info__top1"
        >
          <picture class="m-0">
            <source
              media="(max-width:600px)"
              srcset="../../../assets/images/baner_free_shipping_mb.jpg"
            />
            <img src="../../../assets/images/banerFlash.png" class="w-100" alt="" />
          </picture>
        </router-link>
      </div>
      <div class=" container text-right mt-2">
       
        <div class="weblog-list-main ">
        
   


      
          <section
            v-if="freeShippings.data != ''"
            class="products-list-grid recommended-content-item"
        
          >
            <transition name="fade">
              <div
                v-if="loading"
                :style="'top: ' + loadingPosition"
                class="loading-container"
              >
                <Loading />
              </div>
            </transition>
            
            <Product
              v-for="(product, index) in freeShippings.data"
              :low-opacity="loading"
              :key="index"
              :product="product"
            ></Product>
          </section>
          <section
            v-else
            class="products-list-grid recommended-content-item product-empty bg-white box-shaddow20 py-4 px-5 mt-sm-0 mt-3 "
          >
            <div class="position-relative w-100">
              <div
                v-if="loading"
                :style="'top: ' + loadingPosition"
                class="loading-container"
              >
                <Loading />
              </div>
              <div class="mr-2 fontsize14 weight-bold text-color-444 py-2">
                محصولی یافت نشد.
              </div>
              <router-link
                class="text-color-themeRed text-center d-block"
                to="/products"
                >مشاهده همه</router-link
              >
            </div>
          </section>
          <section
            v-if="freeShippings.data != ''"
            class="list-pagination weblog-list-pagination text-center my-4 py-2 fontsize-medium"
          >
            <pagination
              :router="true"
              :limit="mediaQueries.mobileSize ? 1 : 3"
              :data="freeShippings"
              @pagination-change-page="changePage"
              :disabled="disabled"
              class="justify-content-center"
            >
              <span slot="prev-nav">
                <svg
                  class="page-arrow mb-2"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="22"
                  height="22"
                  viewBox="0 0 226 226"
                  style=" fill:#000000;"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,226v-226h226v226z" fill="none"></path>
                    <g fill="#b2b2b2">
                      <path
                        d="M82.80781,169.67656c1.05938,1.05937 2.47187,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906l52.96875,-52.96875c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-52.96875,-52.96875c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0c-2.11875,2.11875 -2.11875,5.47344 0,7.41563l49.26094,49.26094l-49.26094,49.26094c-2.11875,2.11875 -2.11875,5.29688 0,7.41562z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </span>
              <span slot="next-nav">
                <svg
                  class="page-arrow"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="22"
                  height="22"
                  viewBox="0 0 226 226"
                  style=" fill:#000000;"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,226v-226h226v226z" fill="none"></path>
                    <g fill="#b2b2b2">
                      <path
                        d="M143.19219,56.32344c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0l-52.96875,52.96875c-2.11875,2.11875 -2.11875,5.47344 0,7.41562l52.96875,52.96875c1.05937,1.05937 2.47188,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-49.26094,-49.26094l49.26094,-49.26094c2.11875,-2.11875 2.11875,-5.29687 0,-7.41563z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </span>
            </pagination>
          </section>
        </div>
      </div>

      <ScrollToTop></ScrollToTop>
      <FooterButtons></FooterButtons>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import ScrollToTop from "@/parts/Front/components/ScrollToTop";
import FooterButtons from "@/parts/Front/components/FooterButtons";
import Product from "@/parts/Front/components/product/Product";
import Categories from "@/parts/Front/components/categories/Categories";
import ProductsFilter from "@/parts/Front/components/filter/ProductsFilter";
import ProductsSort from "@/parts/Front/components/filter/ProductsSort";
import ProductsSortMobile from "@/parts/Front/components/filter/ProductsSortMobile";
import ProductsFilterMobile from "@/parts/Front/components/filter/ProductsFilterMobile";
import PagesPath from "@/parts/Front/components/PagesPath";
import Loading from "@/parts/Front/components/shared/Loading";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import WarningPopup from "@/components/warning-popup/WarningPopup";
import HomeCategoreis from "@/parts/Front/components/HomeCategoreis/index.vue";

export default {
  name: "ProductList",
  components: {
    WarningPopup,
    Loading,
    PagesPath,
    ScrollToTop,
    FooterButtons,
    Product,
    Categories,
    ProductsFilter,
    ProductsSort,
    ProductsSortMobile,
    ProductsFilterMobile,
    HomeCategoreis
  },
  inject: ["mediaQueries"],
  data() {
    return {
      query:{
        page:this.$route.query.page??1,
      },
      loading: false,
      // چقدر از بالا به پایین اسکرول شده
      offsetFromTop: 0,
      // آخرین کویری درخواستی رو نگه میداریم که اگر فرق نکرد درخواست نزنیم
      lastQueryRequested: {},
    };
  },
  watch: {
   
    query: {
      handler: function(newVal) {
        this.loadItems();
      },
      deep: true,
    },
   
  },
  created() {
    if (!this.$store.getters["front/getFreeShippings"]) {
      this.$store.dispatch("front/getDataFreeShippings",  this.query);
    }
    // this.loadFiltersFromQuery();

    this.loadItems();
    // if (!this.categories) {
    //   this.$store.dispatch("front/getMainContent", { route: "get-categories" });
    // }
  },
  computed: {
    disabled() {
      // return this.$store.getters["front/getProductsStatus"];
    },
    // categories() {
    //   return this.$store.getters["front/getCategories"];
    // },
    freeShippings() {
      if (this.$store.getters["front/getFreeShippings"] == null) {
        return {
          data: Array(6).fill(null),
        };
      } else {
        return this.$store.getters["front/getFreeShippings"];
      }
    },
    loadingPosition() {
      return 160 + Math.min(1000, this.offsetFromTop) + "px";
    },
   
  },
  mounted() {
    this.offsetFromTop = document.scrollingElement.scrollTop;
    document.removeEventListener("scroll", this.recalculateOffsetFromTop);
    document.addEventListener("scroll", this.recalculateOffsetFromTop);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.recalculateOffsetFromTop);
  },
  methods: {
   
  
    recalculateOffsetFromTop() {
      this.offsetFromTop = document.scrollingElement.scrollTop;
    },
    changePage() {
      this.loadItems();
    },
    async loadItems() {
      // جلوگیری از 2 بار درخواست زدن
      if (this.loading) {
        return;
      }
      this.query.page = this.$route.query.page;
      // اگر فرقی تو کویری نیست درخواست نزن
      if (isEqual(this.lastQueryRequested, this.query)) {
        return;
      }

      this.loading = true;
      // برای فیلتر سایز اگر انتخاب شده بود
      let copyQuery = "";

      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.removeEmptyStrings(copyQuery),
          page: this.$route.query.page,
        },
      });
      this.lastQueryRequested = cloneDeep(this.query);
      await this.$store.dispatch("front/getDataFreeShippings", 
         this.query,
        
      );
      this.loading = false;
    },
    
    removeEmptyStrings(query) {
      let newQuery = {};
      for (let [index, value] of Object.entries(query)) {
        if (value != "") {
          newQuery[index] = value;
        }
      }

      return newQuery;
    },
  },
};
</script>

<style scoped>

.products-list-grid{
  display: grid ;
  grid-template-columns: repeat(4,1fr);
}


.baner_flash {
}
.baner_flash img {
  border-radius: 30px;
  margin-bottom: 2rem;
}





.product-empty {
  grid-template-columns: 2fr !important;
}

.loading-container {
  position: absolute;
  top: 160px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  background: var(--color-theme2);
  border-radius: 10px;
  padding: 10px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: 200ms all;
}

.main >>> .vue-treeselect__multi-value-item {
  color: white;
  background: var(--color-theme);
}
.main >>> .vue-treeselect__value-remove {
  color: white;
}

h2 {
  font-size: 1.75rem;
}



@media screen and (max-width: 580px) {
  
  .baner_flash {
  }
  .baner_flash img {
    border-radius: 20px;
  }
}
</style>
<style></style>

